import '../css/app.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { GymProvider } from '@/contexts/GymContext';
import AppRouter from '@/router';

createRoot(document.getElementById('app')).render(
    <BrowserRouter>
        <ThemeProvider>
            <AuthProvider>
                <GymProvider>
                    <AppRouter />
                </GymProvider>
            </AuthProvider>
        </ThemeProvider>
    </BrowserRouter>
);
